
























































































import "vue-loading-overlay/dist/vue-loading.css";
import "flatpickr/dist/flatpickr.css";
import store from "@/store";
import defineAbilityFor from "./services/ability";
import { Vue, Component } from "vue-property-decorator";
import QScripts from "@/common/qScripts.vue";
import click2Top from "@/common/directives/click2Top";

@Component({
  name: "QApp",
  components: {
    QScripts,
  },
  directives: {
    click2Top
  }
})
export default class QApp extends Vue {
  public isShow = false;
  async created(): Promise<void> {
    await store.dispatch("Auth/fetchCurrentUser");
    // check user using what the company
    this.isShow = true;
    let roleId = null;
    if (this.$store.state.Auth.using_company) {
      for (const userCompany of this.$store.state.Auth.userCompanies) {
        if (userCompany.id === this.$store.state.Auth.using_company) {
          roleId = userCompany.role_id;
        }
      }
    }
    this.$store.state.Auth.userLogging && this.$ability.update(
      defineAbilityFor(this.$store.state.Auth.userLogging.type, roleId).rules
    );
  }

  mounted() {
    this.$nextTick(() => {
      (this.$refs.script as QScripts).muuqBase();
    })
  }
}
